module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "请输入关键词",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": '[' + item.code + '] ' + item.name,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("[" + _vm._s(item.code) + "] " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.discountCondition))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_vm._v(_vm._s(item.startOn) + " ~ " + _vm._s(item.endOn))])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e3a854c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PromotionSelect.vue
// module id = 325
// module chunks = 0